import { gql } from '@apollo/client/core';

export const MODULE_ELECTIVE_OFFERINGS = gql`
  query ModuleElectiveOfferings($moduleId: ID!) {
    moduleElectiveOfferings(module_id: $moduleId) {
      id course_id academic_calendar_id
      course { id course_code course_title unit }
      academicCalendar { id termStructure { id name } }
    }
  }
`;

export const MODULE_ELECTIVE_CANDIDATES = gql`
  query ModuleElectiveCandidates($moduleId: ID!, $calendarId: ID!, $query: String) {
    moduleElectiveCandidates(module_id: $moduleId, academic_calendar_id: $calendarId, query: $query, first: 100) {
      id course_code course_title unit
    }
  }
`;

export const SEARCH_MODULE_ELECTIVES = gql`
  query SearchModuleElectives($moduleId: ID!, $query: String) {
    searchModuleElectiveCourses(module_id: $moduleId, query: $query, first: 100) {
      module_id
      courses { id course_code course_title unit }
    }
  }
`;
